import RegForm from './RegForm';

export default RegForm;
